import { useContext } from 'react';
import { MarketAggregatesContext } from './MarketAggregatesContext';

export const useMarketAggregates = () => {
  const context = useContext(MarketAggregatesContext);
  if (!context) {
    throw new Error('useMarketAggregates must be used within a MarketAggregatesProvider');
  }
  return context;
};
